/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/firmware')({
  component: RouteComponent,
})

async function RouteComponent() {
    // const org_id = getAuthState(AuthStates.activeOrgID)!;
    
    // //Load Image Data
    // useGetImageNamesQuery({});
    // const {data:image_names, isLoading} = useSelector((state:RootState) => selectImageNames()(state));
    // var image_versions:Record<string, FirmwareImageMetadata[]> = {};
    // var image_urls:Record<string, string> = {};

    // image_names && image_names.forEach((_image_name: string) => {
    //     let { data: _image_versions, isLoading } = useSelector((state: RootState) => selectVersionsForImageName(_image_name)(state));
    //     if (_image_versions === null) {
    //         let query_data = useGetVersionsForImageNameQuery({ image_name: _image_name });
    //         if (query_data.data) {
    //             image_versions[_image_name] = query_data.data.entities[query_data.data.ids[0]];
    //         }
    //     } else {
    //         image_versions[_image_name] = _image_versions;
    //     }
    // });

    // Object.keys(image_versions).forEach((_image_name: string) => {
    //     image_versions[_image_name].forEach((img_metadata: FirmwareImageMetadata) => {
    //         let { data: _image_url, isLoading } = useSelector((state: RootState) => selectURLForImage(
    //             _image_name, `${img_metadata.image_version}+${img_metadata.image_build_attrs.concat()}`
    //         )(state));
    //         if (_image_url === null) {
    //             let query_data = useGetURLForImageQuery({
    //                 image_name: _image_name,
    //                 image_version: `${img_metadata.image_version}+${img_metadata.image_build_attrs.concat()}`
    //             });
    //             if (query_data.data) {
    //                 image_urls[uniqueIDForFW(img_metadata)] = query_data.data.entities[query_data.data.ids[0]].image_url;
    //             }
    //         } else {
    //             image_urls[uniqueIDForFW(img_metadata)] = _image_url;
    //         }
    //     });
    // });
    
    // console.log(image_names);
    // console.log(image_versions);
    // console.log(image_urls);

  return <div>
    
  </div>
}
